export default __webpack_public_path__ + "static/su-ukraina--original-aef7a85229569676e140bb86732c1b80.svg";